
import { Component, Prop, Vue } from "vue-property-decorator";
import _ from "underscore";
import DebtRule from "@/models/Liink/DebtRule";
import Lender from "@/models/Liink/Lender";
import FinancialInstitution from "@/models/Liink/FinancialInstitution";

@Component
export default class DebtRuleDrawer extends Vue {
  @Prop() lenders!: Array<Lender>;
  @Prop() financialInstitutions!: Array<FinancialInstitution>;
  @Prop() rule!: DebtRule;
  @Prop() create!: boolean;
  @Prop() open!: boolean;
  @Prop() loading!: boolean;

  rules = {
    lenderId: [
      {
        required: true,
        message: "El campo es obligatorio.",
        trigger: "blur",
      },
    ],
    amountFrom: [
      {
        required: true,
        message: "El campo es obligatorio.",
        trigger: "blur",
      },
      { type: "number", message: "Debe ser un valor numérico." },
    ],
    amountTo: [
      {
        required: true,
        message: "El campo es obligatorio.",
        trigger: "blur",
      },
      { type: "number", message: "Debe ser un valor numérico." },
    ],
    ageFrom: [
      {
        required: true,
        message: "El campo es obligatorio.",
        trigger: "blur",
      },
      { type: "number", message: "Debe ser un valor numérico." },
    ],
    ageTo: [
      {
        required: true,
        message: "El campo es obligatorio.",
        trigger: "blur",
      },
      { type: "number", message: "Debe ser un valor numérico." },
    ],
    institutionId: [
      {
        required: true,
        message: "El campo es obligatorio.",
        trigger: "blur",
      },
    ],
  };

  createRule() {
    (this.$refs["form"] as HTMLFormElement).validate((valid: boolean) => {
      if (valid) {
        this.$emit("create", this.rule);
      }
    });
  }

  updateRule() {
    (this.$refs["form"] as HTMLFormElement).validate((valid: boolean) => {
      if (valid) {
        this.$emit("update", this.rule.id, this.rule);
      }
    });
  }

  closeDrawer() {
    (this.$refs["form"] as HTMLFormElement).clearValidate();
    this.$emit("close");
  }
}
